import { typedDoc, getDocument, setDocumentMerge } from '@/lib/firebase/firestore'
interface BillingSettingsDoc {
  depositThreshold?: number
  depositAutoCancelDays?: number
  depositProviderBufferHours?: number
  depositFirstReminderHoursBefore?: number
  depositFinalReminderHoursBefore?: number
}

interface BookingPolicyDoc {
  minLeadTimeHours?: number
}

export interface BillingSettings {
  depositThreshold: number
  depositAutoCancelDays: number
  depositProviderBufferHours: number
  depositFirstReminderHoursBefore: number
  depositFinalReminderHoursBefore: number
}

export interface BookingPolicy {
  minLeadTimeHours: number
}

const BILLING_DEFAULTS: BillingSettings = {
  depositThreshold: 300,
  depositAutoCancelDays: 10,
  depositProviderBufferHours: 48,
  depositFirstReminderHoursBefore: 72,
  depositFinalReminderHoursBefore: 24,
}

const BOOKING_POLICY_DEFAULTS: BookingPolicy = {
  minLeadTimeHours: 72,
}

export const adminBillingService = {
  async getBillingSettings(): Promise<BillingSettings> {
    const ref = typedDoc<BillingSettingsDoc>('config', 'billingSettings')
    const doc = await getDocument(ref)
    return {
      depositThreshold:                doc?.depositThreshold                ?? BILLING_DEFAULTS.depositThreshold,
      depositAutoCancelDays:           doc?.depositAutoCancelDays           ?? BILLING_DEFAULTS.depositAutoCancelDays,
      depositProviderBufferHours:      doc?.depositProviderBufferHours      ?? BILLING_DEFAULTS.depositProviderBufferHours,
      depositFirstReminderHoursBefore: doc?.depositFirstReminderHoursBefore ?? BILLING_DEFAULTS.depositFirstReminderHoursBefore,
      depositFinalReminderHoursBefore: doc?.depositFinalReminderHoursBefore ?? BILLING_DEFAULTS.depositFinalReminderHoursBefore,
    }
  },

  async updateBillingSettings(data: Partial<BillingSettings>): Promise<void> {
    const ref = typedDoc<BillingSettingsDoc>('config', 'billingSettings')
    // setDoc + merge so the doc is created if missing.
    await setDocumentMerge(ref, data)
  },

  async getBookingPolicy(): Promise<BookingPolicy> {
    const ref = typedDoc<BookingPolicyDoc>('config', 'bookingPolicy')
    const doc = await getDocument(ref)
    return {
      minLeadTimeHours: doc?.minLeadTimeHours ?? BOOKING_POLICY_DEFAULTS.minLeadTimeHours,
    }
  },

  async updateBookingPolicy(data: Partial<BookingPolicy>): Promise<void> {
    const ref = typedDoc<BookingPolicyDoc>('config', 'bookingPolicy')
    await setDocumentMerge(ref, data)
  },
}
